<template>
    <div>
        <div class="header">
            <div class="logout-bg" @click="logout">
                中止
            </div>
            <div class="header-countdown-time">
                {{ countdownTimeStr }}
            </div>
            <div class="login-bg" @click="login">
                登録
            </div>
            <div class="header-title">お客様の新規登録</div>

        </div>

        <div class="container">
            <div class="item-div">
                <div class="item-name">姓
                    <div v-if="mtVcFormCtrl.name.required === 1" class="input-required">*</div>
                </div>
                <input v-model="customer.name" placeholder="例：富山" v-on:input="onNameChanged"
                       :class="mtVcFormCtrl.name.required === 1 && mtVcFormCtrl.name.check === -1?'item-line-input-error':'item-input'"/>
            </div>
            <div class="item-div">
                <div class="item-name">姓カタカナ
                    <div v-if="mtVcFormCtrl.kensaku.required === 1" class="input-required">*</div>
                </div>
                <input
                        :class="mtVcFormCtrl.kensaku.required === 1 && mtVcFormCtrl.kensaku.check === -1?'item-line-input-error':'item-input'"
                        v-model="customer.kensaku" placeholder="例：トヤマ" v-on:input="onNameChanged"/>
            </div>
            <div class="item-div">
                <div class="item-name">名
                    <div v-if="mtVcFormCtrl.customerName.required === 1" class="input-required">*</div>
                </div>
                <input :class="mtVcFormCtrl.customerName.required === 1 && mtVcFormCtrl.customerName.check === -1?'item-line-input-error':'item-input'"
                       v-model="customer.customerName" placeholder="例：太郎" v-on:input="onNameChanged"/>
            </div>
            <div class="item-div">
                <div class="item-name">名カタカナ
                    <div v-if="mtVcFormCtrl.customerNameKensaku.required === 1" class="input-required">*</div>
                </div>
                <input
                        :class="mtVcFormCtrl.customerNameKensaku.required === 1 && mtVcFormCtrl.customerNameKensaku.check === -1?'item-line-input-error':'item-input'"
                        v-model="customer.customerNameKensaku" placeholder="例：タロウ" v-on:input="onNameChanged"/>
            </div>
            <div class="item-div">
                <div class="item-name">郵便番号
                    <div v-if="mtVcFormCtrl.zipCode.required === 1" class="input-required">*</div>
                </div>
                <input type="number" onkeyup="this.value = this.value.replace(/[^0-9]/, '')" v-on:input="onNameChanged"
                       :class="mtVcFormCtrl.zipCode.required === 1 && mtVcFormCtrl.zipCode.check === -1?'item-line-input-error2':'item-input2'"
                       v-model="customer.zipCode" placeholder="ハイフン不要"/>
                <div class="btn-search-bg"><a href="https://www.post.japanpost.jp/zipcode/" target="_blank"
                                              style="text-decoration: none; color: #FFFFFF;">郵便番号検索</a></div>
                <div class="btn-search-address-bg" @click="searchZipcode">郵便番号→住所検索</div>
            </div>
            <div class="item-div">
                <div class="item-name">都道府県
                    <div v-if="mtVcFormCtrl.prefectures.required === 1" class="input-required">*</div>
                </div>
                <input :class="mtVcFormCtrl.prefectures.required === 1 && mtVcFormCtrl.prefectures.check === -1?'item-line-input-error':'item-input'"
                       v-on:input="onNameChanged"
                       v-model="customer.prefectures" placeholder="例：富山県"/>
            </div>
            <div class="item-div">
                <div class="item-name">市区町村
                    <div v-if="mtVcFormCtrl.municipalities.required === 1" class="input-required">*</div>
                </div>
                <input :class="mtVcFormCtrl.municipalities.required === 1 && mtVcFormCtrl.municipalities.check === -1?'item-line-input-error':'item-input'"
                       v-on:input="onNameChanged"
                       v-model="customer.municipalities" placeholder="例：富山市"/>
            </div>
            <div class="item-div">
                <div class="item-name">町域
                    <div v-if="mtVcFormCtrl.area.required === 1" class="input-required">*</div>
                </div>
                <input :class="mtVcFormCtrl.area.required === 1 && mtVcFormCtrl.area.check === -1? 'item-line-input-error':'item-input'"
                       v-on:input="onNameChanged"
                       v-model="customer.area" placeholder="例：本町"/>
            </div>
            <div class="item-div">
                <div class="item-name">番号
                    <div v-if="mtVcFormCtrl.number.required === 1" class="input-required">*</div>
                </div>
                <input :class="mtVcFormCtrl.number.required === 1 && mtVcFormCtrl.number.check === -1?'item-line-input-error':'item-input'"
                       v-on:input="onNameChanged"
                       v-model="customer.number" placeholder="例：１－１－１"/>
            </div>
            <div class="item-div">
                <div class="item-name">建物・号室
                    <div v-if="mtVcFormCtrl.buildingAndRoomNumber.required === 1" class="input-required">*</div>
                </div>
                <input :class="mtVcFormCtrl.buildingAndRoomNumber.required === 1 && mtVcFormCtrl.buildingAndRoomNumber.check === -1?'item-line-input-error':'item-input'"
                       v-model="customer.buildingAndRoomNumber" placeholder="シマースビル 101号室"
                       v-on:input="onNameChanged"/>
            </div>
            <div class="item-div-end">
                <div class="item-name">連絡先
                    <div v-if="mtVcFormCtrl.customerTelnumber.required === 1" class="input-required">*</div>
                </div>
                <input type="number" onkeyup="this.value = this.value.replace(/[^0-9]/, '')"
                       :class="mtVcFormCtrl.customerTelnumber.required === 1 && mtVcFormCtrl.customerTelnumber.check === -1?'item-line-input-error':'item-input'"
                       v-model="customer.customerTelnumber" placeholder="ハイフン不要" v-on:input="onNameChanged"/>
            </div>
            <div style="height: 2vw"></div>
        </div>

        <custom-dialog v-show="showMessage" :show-message="showMessage" :sub-message='subMessage'
                       @dialogClick="dialogClick" :type="dialogType"/>
    </div>
</template>
<script>

import {EXIT_DATA_SAVE_TIPS} from "@/store/message";
import CustomDialog from "@/components/CustomDialog.vue";
import {getFormCtrlInfo, saveCustomerInfo} from "@/utils/api";

export default {
    name: 'addNewCustomer',
    components: {
        CustomDialog
    },
    data() {
        return {
            katagana: /[^アイウエオカキクケコャュョガギグゲゴサシスセソザジズゼゾェタティトゥダデドチヂツァォヅナニヌネノハヒホヘバビブベボパピプペポフマミムメモヤ㇙ユヨッラリルレロワヰ于ヱヲヷヸヴヹヺンーヵヶ]/g,
            countdownTime: 600,
            countdownTimeStr: '',
            taskId: null,
            customer: {
                "name": "",
                "kensaku": "",
                "customerName": "",
                "customerNameKensaku": "",
                "zipCode": "",
                "prefectures": "",
                "municipalities": "",
                "area": "",
                "number": "",
                "buildingAndRoomNumber": "",
                "customerTelnumber": ""
            },
            dialogType: 0,
            showMessage: false,
            subMessage: "",
            state: 0,
            mtVcFormCtrl: {
                name: {required: 1, readonly: 0, visible: 1},
                kensaku: {required: 1, readonly: 0, visible: 1},
                customerName: {required: 1, readonly: 0, visible: 1},
                customerNameKensaku: {required: 1, readonly: 0, visible: 1},
                zipCode: {required: 1, readonly: 0, visible: 1},
                prefectures: {required: 1, readonly: 0, visible: 1},
                municipalities: {required: 1, readonly: 0, visible: 1},
                area: {required: 0, readonly: 0, visible: 1},
                number: {required: 1, readonly: 0, visible: 1},
                buildingAndRoomNumber: {required: 1, readonly: 0, visible: 1},
                customerTelnumber: {required: 0, readonly: 0, visible: 1},
            },
        }
    },
    watch: {
        'customer.kensaku': {
            handler: function (newVal) {
                if (newVal && newVal != '') {
                    console.log('new ' + newVal)
                    this.customer.kensaku = newVal.replaceAll(this.katagana, '');
                }
            }
        },
        'customer.customerNameKensaku': {
            handler: function (newVal) {
                if (newVal && newVal != '') {
                    console.log('new ' + newVal)
                    this.customer.customerNameKensaku = newVal.replaceAll(this.katagana, '');
                }
            }
        }
    },
    created() {

        let that = this;

        document.addEventListener('touchstart', function () {
            that.handleTouchStart()
        }, true);
        that.taskId = setInterval(function () {
            that.countdown();

        }, 1000);
    },
    mounted() {
        let that = this;

        getFormCtrlInfo()
            .then(function (res) {
                console.log(JSON.stringify(res));
                if (res && res.ret === 200) {
                    that.$set(that, 'mtVcFormCtrl', res.data.mtVcFormCtrl)
                }
            })
            .catch(function (err) {
                console.error(err)

            })
    },
    beforeDestroy() {
        clearInterval(this.taskId)
    },
    methods: {
        onNameChanged(e) {
            var that = this;
            that.checkDataNotEmpty(false);
            console.log(JSON.stringify(e));


        },

        countdown() {
            let that = this;
            let diff = that.countdownTime;
            diff--;
            if (diff <= 0) {
                window.document.location = "/ss/menu.php";
                clearInterval(that.taskId)
                return
            }

            let minutes = Math.floor((diff / 60));
            let seconds = Math.floor((diff % 60));
            that.$set(that, 'countdownTimeStr', minutes+':'+((seconds < 10)?'0':'') + seconds)
            that.$set(that, 'countdownTime', diff)

        },
        handleTouchStart() {
            console.log('handleTouchStart')
            if (this.countdownTime !== 600) {
                this.$set(this, 'countdownTime', 600)
            }
        },
        logout() {
            this.state = -1;
            this.showMessageDialog("入力途中のデータは\n保存されません", 2)

        },
        login() {
            let that = this
            if (that.checkDataNotEmpty(true)) {
                // that.$showLoading()
                const loadingInstance1 = that.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                });
                var temp = that.customer;
                Object.entries(temp).forEach(([key, value]) => {
                    if (value === '') {
                        temp[key] = null;
                    }
                });
                saveCustomerInfo(temp)
                    .then(function (res) {
                        console.log(JSON.stringify(res));
                        loadingInstance1.close();
                        if (res && res.ret === 200) {
                            // that.state = 1;
                            // that.showMessageDialog("この機械をスタッ\nフにお返しください", 1)
                            if (res.data && res.data.customerId) {
                                that.$router.push('/carSearchIndex/' + res.data.customerId)
                            }
                        } else {
                            that.showMessageDialog("保存失敗しました。\nまた、再試行してください", 1)
                        }
                    })
                    .catch(function (err) {
                        console.error(err)
                        loadingInstance1.close();
                        that.showMessageDialog(err, 1)
                    })
            } else {
                that.showMessageDialog('必須項目が入力されていません。', 0)
            }


        },
        back() {
            this.state = -2;
            this.showMessageDialog(EXIT_DATA_SAVE_TIPS, 2)
        },
        dialogClick(val) {
            this.$set(this, 'showMessage', false)
            this.$set(this, 'subMessage', '')
            if (val) {
                if (this.state === -1) {
                    window.document.location = "/ss/menu.php";
                } else if (this.state === -2) {
                    this.$router.back();
                }
            }
            this.$set(this, 'state', 0)
        },
        showMessageDialog(subMessage, dialogType) {
            this.$set(this, 'showMessage', true)
            this.$set(this, 'dialogType', dialogType)
            this.$set(this, 'subMessage', subMessage)
        },
        checkDataNotEmpty(isLogin) {
            var notEmptyInput = true;
            if (this.mtVcFormCtrl.name.readonly !== 1 && this.mtVcFormCtrl.name.required === 1 && this.emptyTextCheck(this.customer.name)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.name, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.name, 'check', 0)
            }
            if (this.mtVcFormCtrl.kensaku.readonly !== 1 && this.mtVcFormCtrl.kensaku.required === 1 && this.emptyTextCheck(this.customer.kensaku)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.kensaku, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.kensaku, 'check', 0)
            }
            if (this.mtVcFormCtrl.customerName.readonly !== 1 && this.mtVcFormCtrl.customerName.required === 1 && this.emptyTextCheck(this.customer.customerName)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.customerName, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.customerName, 'check', 0)
            }
            if (this.mtVcFormCtrl.customerNameKensaku.readonly !== 1 && this.mtVcFormCtrl.customerNameKensaku.required === 1 && this.emptyTextCheck(this.customer.customerNameKensaku)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.customerNameKensaku, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.customerNameKensaku, 'check', 0)
            }
            if (this.mtVcFormCtrl.zipCode.readonly !== 1 && this.mtVcFormCtrl.zipCode.required === 1 && this.emptyTextCheck(this.customer.zipCode)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.zipCode, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.zipCode, 'check', 0)
            }
            if (this.mtVcFormCtrl.prefectures.readonly !== 1 && this.mtVcFormCtrl.prefectures.required === 1
                && this.emptyTextCheck(this.customer.prefectures)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.prefectures, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.prefectures, 'check', 0)
            }
            if (this.mtVcFormCtrl.municipalities.readonly !== 1 && this.mtVcFormCtrl.municipalities.required === 1 && this.emptyTextCheck(this.customer.municipalities)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.municipalities, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.municipalities, 'check', 0)
            }
            if (this.mtVcFormCtrl.area.readonly !== 1 && this.mtVcFormCtrl.area.required === 1 && this.emptyTextCheck(this.customer.area)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.area, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.area, 'check', 0)
            }
            if (this.mtVcFormCtrl.number.readonly !== 1 && this.mtVcFormCtrl.number.required === 1 && this.emptyTextCheck(this.customer.number)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.number, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.number, 'check', 0)
            }
            if (this.mtVcFormCtrl.buildingAndRoomNumber.readonly !== 1 && this.mtVcFormCtrl.buildingAndRoomNumber.required === 1 && this.emptyTextCheck(this.customer.buildingAndRoomNumber)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.buildingAndRoomNumber, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.buildingAndRoomNumber, 'check', 0)
            }
            if (this.mtVcFormCtrl.customerTelnumber.readonly !== 1 && this.mtVcFormCtrl.customerTelnumber.required === 1 && this.emptyTextCheck(this.customer.customerTelnumber)) {
                notEmptyInput = false;
                if (isLogin)
                    this.$set(this.mtVcFormCtrl.customerTelnumber, 'check', -1)
            } else {
                this.$set(this.mtVcFormCtrl.customerTelnumber, 'check', 0)
            }
            return notEmptyInput;
        },
        emptyTextCheck(text) {
            return !text;

        },

        searchZipcode() {
            var that = this;
            if (that.customer.zipCode) {
                const loadingInstance1 = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                });
                var urls = 'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + that.customer.zipCode;
                that.$http.get(urls)
                    .then(function (res) {
                        console.log(JSON.stringify(res))
                        if (res.data.status === 400) { //エラー時
                            that.showMessageDialog(res.data.message, 1)
                        } else if (res.data.results === null) {
                            that.showMessageDialog('郵便番号から住所が見つかりませんでした。', 1)
                        } else {
                            that.$set(that.customer, 'prefectures', res.data.results[0].address1)
                            that.$set(that.customer, 'municipalities', res.data.results[0].address2)
                            that.$set(that.customer, 'area', res.data.results[0].address3)
                        }
                        loadingInstance1.close();
                    }).catch(function (err) {
                        console.log(err)
                        loadingInstance1.close();
                    })
            } else {
                that.showMessageDialog('郵便番号を入力してください。', 1)
            }

        },

    }
}
</script>

<style scoped>
.header {
    background: #416ADB;
    height: 8vw;
}

.header-title {
    color: white;
    font-size: 3vw;
    height: 8vw;
    line-height: 8vw;
    margin: 0 auto;
}

.header-countdown-time {
    display: flex;
    color: white;
    font-size: 2.2vw;
    position: absolute;
    float: right;
    right: 0;
    margin-top: 1.5vw;
    margin-right: 3.5vw;
}

.container {
    text-align: center;
    margin: 0 6vw;
}

.item-div {
    display: flex;
    margin: 0.6vw auto;
    border-bottom: 0.1vw solid gray;
}

.item-div-end {
    display: flex;
    margin: 0.6vw auto;
}

.item-name {
    text-align: start;
    font-size: 2.4vw;
    width: 15vw;
    padding: 1vw;
}

.item-input {
    font-size: 2.4vw;
    border-radius: 0.5vw;
    border: black solid 0.2vw;
    width: 66vw;
    margin: 0.5vw;
    padding: 0.5vw;
}

.item-line-input-error {
    font-size: 2.4vw;
    border-radius: 0.5vw;
    border: red solid 0.2vw;
    width: 66vw;
    margin: 0.5vw;
    padding: 0.5vw;
}

.item-input2 {
    font-size: 2.4vw;
    border-radius: 0.5vw;
    border: black solid 0.2vw;
    width: 25vw;
    margin: 0.5vw;
    padding: 0.5vw;
}

.item-line-input-error2 {
    font-size: 2.4vw;
    border-radius: 0.5vw;
    border: red solid 0.2vw;
    width: 25vw;
    margin: 0.5vw;
    padding: 0.5vw;
}

.logout-bg {
    margin: 1.5vw 3vw;
    background: #e7373d;
    font-size: 2.4vw;
    padding: 0.8vw 5vw;
    border-radius: 0.8vw;
    color: #FFFFFF;
    border-width: 0.4vw;
    border-color: #891F25;
    border-style: none none solid none;
    position: absolute;
}

.login-bg {
    margin: 1.5vw 3vw;
    background: #78a950;
    font-size: 2.4vw;
    padding: 0.8vw 5vw;
    border-radius: 0.8vw;
    color: #FFFFFF;
    border-width: 0.4vw;
    border-color: #486630;
    border-style: none none solid none;
    position: absolute;
    right: 10vw;
}


.back-bg {
    width: 18vw;
    margin: 3vw;
    background: #E9373D;
    font-size: 3.6vw;
    right: 0;
    position: absolute;
    padding: 2vw;
    border-radius: 1.5vw;
    color: #FFFFFF;
    border-width: 0.2vw;
    border-color: #8B1F25;
    border-style: none none solid none;
}

.item-line {
    width: 90vw;
    /*  height: 40px;
      line-height: 40px;*/
    padding: 1vw 1vw 1vw 1vw;
    margin: 1vw auto;
    text-align: left;
    font-size: 3.2vw;
    border-radius: 1.5vw;
    border: #083A7E 0.1vw solid;
    background: #FFFFFF;
    color: #083A7E;
    display: table;
}

.input-required {
    display: inline-block;
    text-align: center;
    font-size: 3vw;
    color: red;
}

.btn-search-bg {
    margin: 0.2vw 1vw;
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416AD8;
    color: #FFFFFF;
    font-size: 2vw;
}

.btn-search-address-bg {
    margin: 0.2vw 0 0.2vw 1.6vw;
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #93721F 0.2vw;
    border-style: none none solid none;
    background: #F7BC34;
    color: #212529;
    font-size: 2vw;
}

.floating-window {
    position: fixed;
    width: 300px;
    height: 200px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #f1f1f1;
    border: 1px solid #ddd;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
</style>